import React from 'react';
import { Button } from './Button';

interface PaginationProps {
  page: number;
  setPage: (page: number) => void;
  total: number;
  pageSize: number;
}

const Pagination: React.FC<PaginationProps> = ({ page, setPage, total, pageSize }) => {
  const totalPages = Math.ceil(total / pageSize);
  if (totalPages <= 1) return null;

  // Show up to 5 page numbers, with ... if needed
  let start = Math.max(1, page - 2);
  let end = Math.min(totalPages, page + 2);
  if (end - start < 4) {
    if (start === 1) end = Math.min(5, totalPages);
    if (end === totalPages) start = Math.max(1, totalPages - 4);
  }
  const pages = [];
  for (let i = start; i <= end; i++) pages.push(i);

  const isFirstPage = page === 1;
  const isLastPage = page === totalPages;

  return (
    <div className="flex justify-center items-center gap-3">
      <Button
        variant="secondary"
        size="sm"
        onClick={() => setPage(page - 1)}
        disabled={isFirstPage}
        className="px-4 py-2"
      >
        Previous
      </Button>
      {start > 1 && <span className="px-3 text-text-muted">...</span>}
      {pages.map(p => (
        <Button
          key={p}
          variant={p === page ? 'primary' : 'secondary'}
          size="sm"
          onClick={() => setPage(p)}
          className="px-4 py-2"
        >
          {p}
        </Button>
      ))}
      {end < totalPages && <span className="px-3 text-text-muted">...</span>}
      <Button
        variant="secondary"
        size="sm"
        onClick={() => setPage(page + 1)}
        disabled={isLastPage}
        className="px-4 py-2"
      >
        Next
      </Button>
    </div>
  );
};

export default Pagination; 